export const convertValueObjectToNull = (obj, valueToConvert, exceptField?) => {
  if (obj) {
    const newObj = { ...obj };
    const arrObj = Object.keys(newObj);
    arrObj.forEach(key => {
      if (!newObj[key]) {
        if (exceptField) {
          if (key !== exceptField) {
            newObj[key] = valueToConvert;
          }
        } else {
          newObj[key] = valueToConvert;
        }
      }
    });
    return newObj;
  }
  return null;
};
